/* Mobile nav: drill-down panels inside the header drawer.
   Event delegation, so it keeps working when the theme re-renders the drawer. */
(function () {
  'use strict';

  if (window.__wbMnavBound) return;
  window.__wbMnavBound = true;

  function panelsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-wb-panel]'));
  }

  function show(root, id) {
    var track = root.querySelector('[data-wb-mnav-track]');
    var panels = panelsOf(root);
    var idx = -1;
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].getAttribute('data-wb-panel') === id) idx = i;
    }
    if (!track || idx < 0) return;

    panels.forEach(function (panel, i) {
      var active = i === idx;
      panel.classList.toggle('is-active', active);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) {
        panel.removeAttribute('inert');
        panel.scrollTop = 0;
      } else {
        panel.setAttribute('inert', '');
      }
    });

    track.style.transform = 'translateX(-' + idx * 100 + '%)';
    if (track.parentElement) track.parentElement.scrollLeft = 0;
    root.setAttribute('data-wb-current', id);
  }

  function history(root) {
    var h = (root.getAttribute('data-wb-history') || 'root').split(',');
    return h.filter(Boolean);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-wb-open]');
    if (opener) {
      var root = opener.closest('[data-wb-mnav]');
      if (!root) return;
      event.preventDefault();
      var id = opener.getAttribute('data-wb-open');
      var h = history(root);
      h.push(id);
      root.setAttribute('data-wb-history', h.join(','));
      show(root, id);
      return;
    }

    var back = event.target.closest('[data-wb-back]');
    if (back) {
      var r = back.closest('[data-wb-mnav]');
      if (!r) return;
      event.preventDefault();
      var hh = history(r);
      if (hh.length > 1) hh.pop();
      r.setAttribute('data-wb-history', hh.join(','));
      show(r, hh[hh.length - 1]);
    }
  });

  // back to the first panel whenever the drawer closes
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || details.id !== 'Details-menu-drawer-container' || details.open) return;
      var root = details.querySelector('[data-wb-mnav]');
      if (root && root.getAttribute('data-wb-current') && root.getAttribute('data-wb-current') !== 'root') {
        root.setAttribute('data-wb-history', 'root');
        show(root, 'root');
      }
    },
    true
  );
})();
